import {Component, ElementRef, Renderer2, forwardRef, Output, EventEmitter, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from "@angular/forms";
import {ToggleItemComponent} from "./toggle.item.component";
import {isUndefined, find} from "lodash";

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ToggleButtonComponent),
    multi: true
};

const noop = () => {
};

@Component({
    selector: 'toggle-button',
    template: require('./toggle.button.template.html'),
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ToggleButtonComponent implements ControlValueAccessor {

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    @Input('disabled')
    disabled: boolean = false;

    @Output()
    onChange: EventEmitter<any> = new EventEmitter();

    //The internal data model
    _innerValue: any = {};
    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;

    writeValue(obj: any): void {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChange.subscribe(fn);
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }


    //get accessor
    get innerValue(): any {
        return this._innerValue;
    };

    //set accessor including call the onchange callback
    set innerValue(v: any) {
        if (v !== this._innerValue) {
            this._innerValue = v;
            this.onChange.emit(this._innerValue);
        }
    }

    private items: Array<ToggleItemComponent> = new Array<ToggleItemComponent>();

    private currentItem: ToggleItemComponent;
    @Input() autoWidth: boolean = true;

    ngAfterContentInit() {
        setTimeout(() => {
            let selectedItem = this.getItemByValue(this._innerValue);
            if (!isUndefined(selectedItem) && selectedItem !== this.currentItem) {
                this.selectItem(selectedItem);
            }
        }, 0);
        this.setupStyles();
    }

    //DOM READY
    ngAfterViewChecked() {
        if (this.autoWidth) {
            this.items.forEach((item: ToggleItemComponent) => {
                item.setWidth(100 / this.items.length + '%');
                item.updateView();
            });
        } else {
            this.items.forEach((item: ToggleItemComponent) => {
                item.setWidth('100%');
                item.updateView();
            });
        }
    }

    public registerChild(child: ToggleItemComponent) {
        this.items.push(child);
    }

    private getItemByValue(value) {
        return find(this.items, (item: ToggleItemComponent) => {
            return item.getValue() === value
        });
    }

    private setupStyles() {
        this.renderer.addClass(this.el.nativeElement, 'btn-group');
        this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
    }

    public selectItem(item: ToggleItemComponent) {
        this.items.forEach((child: ToggleItemComponent) => {
            if (child === item) {
                child.activateItem();
            } else {
                child.deactivateItem();
            }
        });
        this.currentItem = item;
        this.writeValue(item.getValue());
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/toggle/toggle.button.component.ts